import { formatQueryParams } from "@grindex-client/common/js/helpers/query-parser";
import ApiConfig from "@grindex-common/helpers/apiConfig.class";

const api = new ApiConfig();

const resolveApiUrl = (actionUrl, parameters = {}) => {
	const urlParams = formatQueryParams(parameters);
	return `/${api.apiLanguage()}/${actionUrl}/${api.apiNode()}${urlParams}`;
};

export { resolveApiUrl };
